<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import WorkOrderTablePropertyCell from "../../../../../../_shared/_modules/work-order-table-property-cell"
  import type { ContactPointReviewDraft, ContactPointReviewRow } from "../../contract"

  let { row, disabled }: InboxWorkflowCellProps<ContactPointReviewRow, ContactPointReviewDraft> =
    $props()
</script>

<WorkOrderTablePropertyCell addressLabel={row.addressLabel} unitLabel={row.unitLabel} {disabled} />
